/* © 2024-2026 Johannes Roob. Proprietärer Code. Keine Nutzung oder Weitergabe ohne Erlaubnis. | Proprietary code. No use or distribution without permission. */

import { FormManager } from "../../util/FormManager.js";

export class Form {
    #formManager: FormManager;
    #element: HTMLElement;
    #id: string;
    #callingFormId: string = "";
    #isModal: boolean = false;

    constructor(formManager: FormManager, element: HTMLElement) {
        if (!element.matches("div.Form")) {
            throw new Error("this is not a Form");
        }

        this.#formManager = formManager;
        this.#element = element;
        this.#id = element.id;

        let input: HTMLInputElement | null;
        // Form.CallingForm.Id
        input = element.querySelector<HTMLInputElement>('input[type="hidden"][name="Form.CallingForm.Id"]');

        if (input !== null) {
            if (input.value !== "") {
                this.#callingFormId = input.value;
            }
        }

        // Form.IsModal
        input = this.#element.querySelector<HTMLInputElement>('input[type="hidden"][name="Form.IsModal"]');

        if (input !== null) {
            const lower = input.value.trim().toLowerCase();
            this.#isModal = lower === "true" || lower === "1" || lower === "yes" || lower === "on";
        }
    }

    init() {
        this.isVisible = true;
        this.focusFirstInput();
    }

    destroy() {
        /* this.#formManager = undefined;
        this.#element = undefined; */
    }

    get formManager() {
        return this.#formManager;
    }

    get element() {
        return this.#element;
    }

    get id() {
        return this.#id;
    }

    get callingFormId() {
        return this.#callingFormId;
    }

    get isModal() {
        return this.#isModal;
    }

    /* TODO isVisible */

    get isVisible() {
        return this.#element.dataset.isVisible !== undefined;
    }

    set isVisible(value) {
        if (value === true) {
            this.#element.dataset.isVisible = "";
        } else {
            delete this.#element.dataset.isVisible;
        }
    }

    focusFirstInput() {
        const inputs = this.#element.querySelectorAll<HTMLInputElement>('input:not([type="hidden"]), textarea, select');

        for (const input of inputs) {
            if (input.disabled) {
                continue;
            }

            input.focus();
            break;
        }
    }
}